import React from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import iconTrashCan from "../../../../img/icons/trash-can.svg";
import { Image } from "../../../common/Image";
import { IVoucherDiscount } from "../../../models/catalogue";

import styles from "./common-minimal.module.scss";

export const VoucherLineMinimalEnhanced = (props: {
    voucherData: IVoucherDiscount;
    onRemoveLine: (code: string) => void;
}): React.ReactNode => (
    <section className={styles.virtualLine}>
        {props.voucherData.desktop_image && (
            <Image
                alt={props.voucherData.name}
                src={props.voucherData.desktop_image}
            />
        )}
        <div className={styles.titleContainer}>
            <h2 className={styles.productTitle}>{props.voucherData.name}</h2>
            <span>
                {t`Qty:`} &nbsp; {props.voucherData.freq}
            </span>
        </div>
        <div className={styles.codeContainer}>
            <button
                aria-label={t`Remove`}
                onClick={() =>
                    props.onRemoveLine(props.voucherData.voucher.code)
                }
                className={`${styles.removeButton} al-voucher-line__button--remove`}
            >
                <SVG
                    className={styles.icon}
                    src={iconTrashCan}
                    aria-hidden="true"
                />
            </button>
        </div>
    </section>
);
